import { useEffect } from 'react';
import { CableConsumer } from 'lib/cable_consumer';

interface CvProcessingListenerProps {
  channel: string;
  fallbackUrl: string;
}

export default function CvProcessingListener({ channel, fallbackUrl }: CvProcessingListenerProps) {
  useEffect(() => {
    const subscription = CableConsumer.subscriptions.create(
      { channel },
      {
        received(data: { status: string; redirect_url?: string }) {
          if (data.status === 'complete') {
            window.location.href = data.redirect_url || fallbackUrl;
          }
        },
      }
    );

    return () => subscription.unsubscribe();
  }, [channel, fallbackUrl]);

  return null;
}
